<button mat-stroked-button class="filter-btn" [matBadge]="badge" [disabled]="disabled">
  <i class="material-symbols-outlined">filter_alt</i>
  <span *ngIf="label"> {{ label }} </span>
</button>
